import PersonalFinancialReadinessContainer from '../bundles/FindBob/containers/PersonalFinancialReadinessContainer';
// Global design tokens (CSS variables) – must be loaded once at app start
import '../design-canon/tokens/global.css';

// Succeedo SMB Platform
import SucceedoLoginContainer from '../bundles/FindBob/containers/SucceedoLoginContainer';
import SucceedoSponsorLandingContainer from '../bundles/FindBob/containers/SucceedoSponsorLandingContainer';
import SucceedoPersonaWizardContainer from '../bundles/FindBob/containers/SucceedoPersonaWizardContainer';
import SucceedoDashboardContainer from '../bundles/FindBob/containers/SucceedoDashboardContainer';
import SucceedoGeorgeContainer from '../bundles/FindBob/containers/SucceedoGeorgeContainer';
import SucceedoWorkspaceContainer from '../bundles/FindBob/containers/SucceedoWorkspaceContainer';
import SucceedoAssessmentContainer from '../bundles/FindBob/containers/SucceedoAssessmentContainer';
import SucceedoValuationContainer from '../bundles/FindBob/containers/SucceedoValuationContainer';
import SucceedoPartnerDirectoryContainer from '../bundles/FindBob/containers/SucceedoPartnerDirectoryContainer';
import SucceedoPartnerProfileContainer from '../bundles/FindBob/containers/SucceedoPartnerProfileContainer';
import SucceedoPartnerOnboardingContainer from '../bundles/FindBob/containers/SucceedoPartnerOnboardingContainer';
import SucceedoDealRoomContainer from '../bundles/FindBob/containers/SucceedoDealRoomContainer';
import SucceedoDealRoomListingContainer from '../bundles/FindBob/containers/SucceedoDealRoomListingContainer';
import SucceedoDealRoomEditContainer from '../bundles/FindBob/containers/SucceedoDealRoomEditContainer';
import SucceedoMarketplaceContainer from '../bundles/FindBob/containers/SucceedoMarketplaceContainer';
import SucceedoMarketplaceListingContainer from '../bundles/FindBob/containers/SucceedoMarketplaceListingContainer';
import SucceedoDealRoomInquiriesContainer from '../bundles/FindBob/containers/SucceedoDealRoomInquiriesContainer';
import SucceedoSavedSearchesContainer from '../bundles/FindBob/containers/SucceedoSavedSearchesContainer';
import SucceedoActionPlanContainer from '../bundles/FindBob/containers/SucceedoActionPlanContainer';
import SucceedoPartnerDashboardContainer from '../bundles/FindBob/containers/SucceedoPartnerDashboardContainer';
import SucceedoPartnerLeadDetailContainer from '../bundles/FindBob/containers/SucceedoPartnerLeadDetailContainer';
import SucceedoPartnerMessagesContainer from '../bundles/FindBob/containers/SucceedoPartnerMessagesContainer';
import SucceedoMessagesContainer from '../bundles/FindBob/containers/SucceedoMessagesContainer';
import SucceedoPartnerSignupContainer from '../bundles/FindBob/containers/SucceedoPartnerSignupContainer';
import SucceedoPartnerEngagementsContainer from '../bundles/FindBob/containers/SucceedoPartnerEngagementsContainer';
import SucceedoPartnerEarningsContainer from '../bundles/FindBob/containers/SucceedoPartnerEarningsContainer';
import SucceedoPartnerProfileEditorContainer from '../bundles/FindBob/containers/SucceedoPartnerProfileEditorContainer';
import SucceedoFinancingCalculatorContainer from '../bundles/FindBob/containers/SucceedoFinancingCalculatorContainer';
import SucceedoDealStructureContainer from '../bundles/FindBob/containers/SucceedoDealStructureContainer';
import SucceedoProfileContainer from '../bundles/FindBob/containers/SucceedoProfileContainer';
import SucceedoUnderstandingContainer from '../bundles/FindBob/containers/SucceedoUnderstandingContainer';
import SucceedoTeamContainer from '../bundles/FindBob/containers/SucceedoTeamContainer';
import SucceedoIntegrationsContainer from '../bundles/FindBob/containers/SucceedoIntegrationsContainer';
import SucceedoDealTeamWorkspaceContainer from '../bundles/FindBob/containers/SucceedoDealTeamWorkspaceContainer';
import SucceedoDealTeamSnapshotViewContainer from '../bundles/FindBob/containers/SucceedoDealTeamSnapshotViewContainer';
// Support System
import SupportHelpDrawerContainer from '../bundles/FindBob/containers/SupportHelpDrawerContainer';
import HelpCenter from '../bundles/FindBob/components/Succession/HelpCenter/HelpCenter';
import ManagerViewContainer from '../bundles/FindBob/components/Succession/ManagerView/ManagerViewContainer';
import WealthGapWizardContainer from '../bundles/FindBob/containers/WealthGapWizardContainer';
import ValueGapWizardContainer from '../bundles/FindBob/containers/ValueGapWizardContainer';
import ProfitGapWizardContainer from '../bundles/FindBob/containers/ProfitGapWizardContainer';
import OwnerDiagnosticContainer from '../bundles/FindBob/containers/OwnerDiagnosticContainer';
import BuyerReadinessAssessmentContainer from '../bundles/FindBob/containers/Succession/BuyerReadinessAssessmentContainer';
import ReactOnRails from 'react-on-rails';
import JitSyncPending from '../bundles/FindBob/components/JitSyncPending';
import ActivationCheckEmailContainer from '../bundles/FindBob/containers/ActivationCheckEmailContainer';

import CompanyAdminApp from '../bundles/FindBob/startup/CompanyAdminApp';
import UserRating from '../bundles/FindBob/containers/UserRatingContainer';
import SocialButtons from '../bundles/FindBob/containers/SocialButtonsContainer';
import FindBobApp from '../bundles/FindBob/startup/FindBobApp';
import AdminNavigation from '../bundles/FindBob/containers/NavigationDrawerContainer';
import CurrentPipelineActivities from '../bundles/FindBob/components/Admin/CurrentPipelineActivities';
import BrowserDetectionBanner from '../bundles/FindBob/components/BrowserDetectionBanner/BrowserDetectionBanner';
import AnalyticsPipelineSummaryReportContainer from '../bundles/FindBob/containers/Reports/AnalyticsPipelineSummaryReportContainer';
import MyOpenTasksContainer from '../bundles/FindBob/containers/MyOpenTasksContainer';
import MatchProfileContainer from '../bundles/FindBob/containers/MatchProfileContainer';
import RevenueContainer from '../bundles/FindBob/containers/RevenueContainer';
import SuggestedUsersPanel from '../bundles/FindBob/components/SuggestedUsersPanel/SuggestedUsersPanel';
import SuggestedDealsPanel from '../bundles/FindBob/components/SuggestedDealsPanel/SuggestedDealsPanel';
import Snackbars from '../bundles/FindBob/components/Snackbars/Snackbars';
import CarouselContainer from '../bundles/FindBob/containers/CarouselContainer';
import ChatWidget from '../bundles/FindBob/containers/ChatWidgetContainer';
import Spotlight from '../bundles/FindBob/containers/SpotlightContainer';
import FileTab from '../bundles/FindBob/containers/FileTabContainer';
import TrendingBobsContainer from '../bundles/FindBob/containers/TrendingBobsContainer';
import ProfileDrawerContainer from '../bundles/FindBob/containers/ProfileDrawerContainer';
import NotificationsMenuContainer from '../bundles/FindBob/containers/NotificationsMenuContainer';
import LoansOtpCalculator from '../bundles/FindBob/containers/LoansOtpCalculatorContainer';
import LoansRepaymentCalculator from '../bundles/FindBob/containers/LoansRepaymentCalculatorContainer';
import FinancingCalculatorContainer from '../bundles/FindBob/containers/Succession/FinancingCalculatorContainer';
import TransitionGoalSelector from '../bundles/FindBob/containers/TransitionGoalSelectorContainer';
import UserProfileContainer from '../bundles/FindBob/containers/UserProfileContainer';
import ManagerConfirmation from '../bundles/FindBob/components/ManagerConfirmation/ManagerConfirmation';
import FBSelect from '../bundles/FindBob/components/FBSelect/FBSelect';
import CloseDealButton from '../bundles/FindBob/components/CloseDealButton/CloseDealButton';
import DCFList from "../bundles/FindBob/components/DCFList/DCFList";
import DashboardMarketplaceTicker from '../bundles/FindBob/components/DashboardMarketplaceTicker/DashboardMarketplaceTicker';
import SuccessionReadinessWidgetContainer from '../bundles/FindBob/containers/SuccessionReadinessWidgetContainer';
import PartialSalesContainer from '../bundles/FindBob/containers/PartialSalesContainer';
import SuccessionPartialSalesContainer from '../bundles/FindBob/components/Succession/PartialSales/SuccessionPartialSalesContainer';
import SuccessionPartialSalesWizard from '../bundles/FindBob/components/Succession/PartialSales/SuccessionPartialSalesWizard';
import SupportDrawerContainer from '../bundles/FindBob/containers/SupportDrawerContainer';
import LeadDrawerContainer from '../bundles/FindBob/containers/LeadDrawerContainer';
import AIHeadline from '../bundles/FindBob/components/AiHeadline/AiHeadline';
import AIBio from '../bundles/FindBob/components/AiBio/AiBio';
import SuccessionDashboardContainer from '../bundles/FindBob/containers/SuccessionDashboardContainer';
import SuccessionQuestionnaireContainer from '../bundles/FindBob/containers/SuccessionQuestionnaireContainer';
import SuccessionRolodexContainer from '../bundles/FindBob/containers/SuccessionRolodexContainer';
import SuccessionSponsoredOwnersContainer from '../bundles/FindBob/containers/SuccessionSponsoredOwnersContainer';
import ValuationTileContainer from '../bundles/FindBob/containers/ValuationTileContainer';
import SuccessionValuationContainer from '../bundles/FindBob/containers/SuccessionValuationContainer';
import MultiLineValuationContainer from '../bundles/FindBob/containers/MultiLineValuationContainer';
import BCPGeneratorContainer from '../bundles/FindBob/containers/BCPGeneratorContainer';
import BcpTileContainer from '../bundles/FindBob/containers/BcpTileContainer';
import CatastropheGeneratorContainer from '../bundles/FindBob/containers/CatastropheGeneratorContainer';
import CatastropheTileContainer from '../bundles/FindBob/containers/CatastropheTileContainer';
import SuccessionPlanningGeneratorContainer from '../bundles/FindBob/containers/SuccessionPlanningGeneratorContainer';
import SuccessionPlanningTileContainer from '../bundles/FindBob/containers/SuccessionPlanningTileContainer';
import SuccessionPlanningSummaryPage from '../bundles/FindBob/components/Succession/SuccessionPlanningSummaryPage';
import HeaderWrapper from '../bundles/FindBob/components/Succession/HeaderWrapper';
import UnifiedIntakeContainer from '../bundles/FindBob/containers/UnifiedIntakeContainer';
import ConsultantAssessmentContainer from '../bundles/FindBob/containers/ConsultantAssessmentContainer';
import ConsultantAssessmentReport from '../bundles/FindBob/components/ConsultantAssessment/ConsultantAssessmentReport';

// Succession Cash Flow Analysis Components
import CfaContainer from '../bundles/FindBob/components/Succession/CashFlowAnalysis/containers/CfaContainer';
import CfaWizardContainer from '../bundles/FindBob/containers/CfaWizardContainer';
import CfaEditContainer from '../bundles/FindBob/components/Succession/CashFlowAnalysis/containers/CfaEditContainer';
import CfaResultsContainer from '../bundles/FindBob/components/Succession/CashFlowAnalysis/containers/CfaResultsContainer';


// New Succession CFA Start and Wizard Components
import SuccessionCfaStartContainer from '../bundles/FindBob/components/Succession/CashFlowAnalysis/containers/SuccessionCfaStartContainer';
import SuccessionCfaWizardContainer from '../bundles/FindBob/components/Succession/CashFlowAnalysis/containers/SuccessionCfaWizardContainer';
import EducationContainer from '../bundles/FindBob/containers/EducationContainer';
import MediaContactContainer from '../bundles/FindBob/containers/MediaContactContainer';
import GettingStartedContainer from '../bundles/FindBob/containers/GettingStartedContainer';
import SuccessionListSearchContainer from '../bundles/FindBob/containers/Search/SuccessionListSearchContainer';
import SuccessionMapSearchContainer from '../bundles/FindBob/containers/Search/SuccessionMapSearchContainer';
import SuccessionProfileDrawerContainer from '../bundles/FindBob/containers/Succession/SuccessionProfileDrawerContainer';
import SuccessionDealsContainer from '../bundles/FindBob/containers/Succession/Deals/SuccessionDealsContainer';
import ScheduleMeetingContainer from '../bundles/FindBob/containers/Succession/ScheduleMeetingContainer';
import BuyerRoomContainer from '../bundles/FindBob/containers/Succession/BuyerRoomContainer';
import BuyerRoomGraphQLContainer from '../bundles/FindBob/containers/Succession/BuyerRoomGraphQLContainer';
import BuyerWorkflowControlsContainer from '../bundles/FindBob/containers/Succession/BuyerWorkflowControlsContainer';
import ModernMessagingContainer from '../bundles/FindBob/containers/ModernMessagingContainer';
import ChatPanel from '../bundles/FindBob/components/Succession/Messaging/ChatPanel/ChatPanel';
import SellerValueMetricContainer from '../bundles/FindBob/containers/SellerValueMetricContainer';
import ProvinceMapModalContainer from '../bundles/FindBob/containers/ProvinceMapModalContainer';
import OnboardingContainer from '../bundles/FindBob/containers/OnboardingContainer';
import OnboardingWizard from '../bundles/FindBob/components/Onboarding/OnboardingWizard';
import SuccessionProfileEditContainer from '../bundles/FindBob/containers/Succession/SuccessionProfileEditContainer';
import ThemeToggleContainer from '../bundles/FindBob/containers/ThemeToggleContainer';
import SuccessionThemeProvider from '../bundles/FindBob/components/Succession/SuccessionThemeProvider';
import SuccessionMessagesContainer from '../bundles/FindBob/containers/SuccessionMessagesContainer';
import SuccessionSettingsContainer from '../bundles/FindBob/containers/SuccessionSettingsContainer';
import QuickNotesReportsContainer from '../bundles/FindBob/components/QuickNotesReports/QuickNotesReportsContainer';
import QuickNotesFormContainer from '../bundles/FindBob/containers/QuickNotesFormContainer';
import QuickNotesContainer from '../bundles/FindBob/containers/QuickNotesContainer';
import 'babel-polyfill';
import ActionPlanSelectionContainer from '../bundles/FindBob/containers/ActionPlanSelectionContainer';
import SprintHeader from '../bundles/FindBob/components/Sprints/SprintHeader';
import SprintMetricsStripSimple from '../bundles/FindBob/components/Sprints/SprintMetricsStripSimple';
import SprintListTable from '../bundles/FindBob/components/Sprints/SprintListTable';
import SprintKanbanBoard from '../bundles/FindBob/components/Sprints/SprintKanbanBoard';
import ValueAccelerationSprintContainer from '../bundles/FindBob/containers/ValueAccelerationSprintContainer';
import MapTable from '../bundles/FindBob/components/AdvisorMap/MapTable';
import MapFilters from '../bundles/FindBob/components/AdvisorMap/MapFilters';
import SprintsListContainer from '../bundles/FindBob/containers/SprintsListContainer';
import SprintDetailContainer from '../bundles/FindBob/containers/SprintDetailContainer';
import AdvisorMapBacklogContainer from '../bundles/FindBob/containers/AdvisorMapBacklogContainer';
import AdvisorMapBacklogPage from '../bundles/FindBob/startup/AdvisorMapBacklogPage';
import SprintDetailPage from '../bundles/FindBob/startup/SprintDetailPage';
import SprintsListPage from '../bundles/FindBob/startup/SprintsListPage';
import AssessmentPromptPage from '../bundles/FindBob/startup/AssessmentPromptPage';
import HomeContainer from '../bundles/FindBob/containers/HomeContainer';
import HomePageContainer from '../bundles/FindBob/containers/HomePageContainer';
import SidebarNavigation from '../bundles/FindBob/components/Succession/SidebarNavigation';
import TopCategories from '../bundles/FindBob/components/Home/TopCategories';
import SuccessionCategoryPage from '../bundles/FindBob/components/Succession/SuccessionCategoryPage';
import SuccessionCategoryPageContainer from '../bundles/FindBob/containers/SuccessionCategoryPageContainer';
import GrowthCategoryPageContainer from '../bundles/FindBob/containers/GrowthCategoryPageContainer';
import ValueAccelerationCategoryPageContainer from '../bundles/FindBob/containers/ValueAccelerationCategoryPageContainer';
import OpportunitiesCategoryPageContainer from '../bundles/FindBob/containers/OpportunitiesCategoryPageContainer';
import ModernizedMotivationOnboardingContainer from '../bundles/FindBob/containers/ModernizedMotivationOnboardingContainer.jsx';
import EducationalContent from '../bundles/FindBob/components/EducationalContent/EducationalContent';
import LaunchPadContainer from '../bundles/FindBob/containers/LaunchPadContainer';
import PactBuilderContainer from '../bundles/FindBob/containers/PactBuilderContainer';
import AssistantPage from '../bundles/FindBob/components/Succession/AssistantPage';
import AssistantModalTest from '../bundles/FindBob/components/Succession/AssistantModalTest.jsx';
import MultiLineAdminContainer from '../bundles/FindBob/containers/Admin/MultiLineAdminContainer';
import AdminUserValuationPage from '../bundles/FindBob/startup/admin/AdminUserValuationPage.jsx';
import VaultContainer from '../bundles/FindBob/containers/VaultContainer';
import QuickbooksConnectContainer from '../bundles/FindBob/containers/QuickbooksConnect/QuickbooksConnectContainer';
import CoachLedMarketplacePage from '../bundles/FindBob/startup/coachLed/CoachLedMarketplacePage.jsx';
import CoachLedProgramDetailPage from '../bundles/FindBob/startup/coachLed/CoachLedProgramDetailPage.jsx';
import CoachLedProgramEnrollmentPage from '../bundles/FindBob/startup/coachLed/CoachLedProgramEnrollmentPage.jsx';
import CoachLedCoachProfilePage from '../bundles/FindBob/startup/coachLed/CoachLedCoachProfilePage.jsx';
import CoachLedAdminMarketplacePage from '../bundles/FindBob/startup/coachLed/CoachLedAdminMarketplacePage.jsx';
import CoachLedEnrollmentWorkspacePage from '../bundles/FindBob/startup/coachLed/CoachLedEnrollmentWorkspacePage.jsx';
import CoachLedCoachPortalPage from '../bundles/FindBob/startup/coachLed/CoachLedCoachPortalPage.jsx';
import CoachLedParticipantValuationPage from '../bundles/FindBob/startup/coachLed/CoachLedParticipantValuationPage.jsx';
import CoachLedProgramEditorPage from '../bundles/FindBob/startup/coachLed/CoachLedProgramEditorPage.jsx';
import CoachLedCoachProfileSettingsPage from '../bundles/FindBob/startup/coachLed/CoachLedCoachProfileSettingsPage.jsx';
import TemplateListContainer from '../bundles/FindBob/containers/EmailPlatform/TemplateListContainer';
import TemplateBuilderContainer from '../bundles/FindBob/containers/EmailPlatform/TemplateBuilderContainer';
import SequenceListContainer from '../bundles/FindBob/containers/EmailPlatform/SequenceListContainer';
import SequenceBuilderContainer from '../bundles/FindBob/containers/EmailPlatform/SequenceBuilderContainer';
import EnrollmentManagerContainer from '../bundles/FindBob/containers/EmailPlatform/EnrollmentManagerContainer';
import TriggerListContainer from '../bundles/FindBob/containers/EmailPlatform/TriggerListContainer';
import TriggerBuilderContainer from '../bundles/FindBob/containers/EmailPlatform/TriggerBuilderContainer';
import EmailLogViewerContainer from '../bundles/FindBob/containers/EmailPlatform/EmailLogViewerContainer';

// Plan Builder Components (Wrapped in Container)
import {
  PlanBuilder,
  SuccessionPlansIndex,
  NewSuccessionPlan,
  PlanCompletionCelebration,
  PlanExport
} from '../bundles/FindBob/components/PlanBuilder/PlanBuilderContainer';

// Student Platform Components
import StudentLanding from '../bundles/FindBob/containers/StudentPlatform/LandingContainer';
import StudentSignup from '../bundles/FindBob/containers/StudentPlatform/SignupContainer';
import StudentDashboard from '../bundles/FindBob/containers/StudentPlatform/StudentDashboardContainer';
import StudentProfile from '../bundles/FindBob/containers/StudentPlatform/StudentProfileContainer';
import OpportunityDetail from '../bundles/FindBob/containers/StudentPlatform/OpportunityDetailContainer';
import StudentMessagesContainer from '../bundles/FindBob/containers/StudentPlatform/StudentMessagesContainer';
import HiringPostDetail from '../bundles/FindBob/containers/StudentPlatform/HiringPostDetailContainer';
import HiringPostForm from '../bundles/FindBob/containers/StudentPlatform/HiringPostFormContainer';
import MyHiringPosts from '../bundles/FindBob/containers/StudentPlatform/MyHiringPostsContainer';
import StudentProspectsContainer from '../bundles/FindBob/containers/Succession/StudentProspectsContainer';
import RecruitmentHubContainer from '../bundles/FindBob/containers/Hiring/RecruitmentHubContainer';

if (!String.prototype.startsWith) {
    String.prototype.startsWith = function(search, pos) {
        return this.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
    };
}

// This is how react_on_rails can see the HelloWorld in the browser.
import MotivationAdoptionContainer from '../bundles/FindBob/containers/MotivationAdoptionContainer';
import GoalsAdmin from '../bundles/FindBob/components/MotivationAdoption/GoalsAdmin';

import RagAdminDashboardContainer from '../bundles/FindBob/containers/RagAdminDashboardContainer';

ReactOnRails.register({
    MotivationAdoptionDashboard: MotivationAdoptionContainer,
    MotivationAdoptionGoalsAdmin: GoalsAdmin,
    RagAdminDashboard: RagAdminDashboardContainer,
    CompanyAdminApp,
    UserRating,
    SocialButtons,
    FindBobApp,
    AdminNavigation,
    CurrentPipelineActivities,
    AnalyticsPipelineSummaryReportContainer,
    MyOpenTasksContainer,
    MatchProfileContainer,
    RevenueContainer,
    SuggestedUsersPanel,
    SuggestedDealsPanel,
    Snackbars,
    CarouselContainer,
    ChatWidget,
    Spotlight,
    FileTab,
    TrendingBobsContainer,
    ProfileDrawerContainer,
    NotificationsMenuContainer,
    LoansOtpCalculator,
    LoansRepaymentCalculator,
    FinancingCalculator: FinancingCalculatorContainer,
    TransitionGoalSelector,
    UserProfileContainer,
    BrowserDetectionBanner,
    ManagerConfirmation,
    FBSelect,
    CloseDealButton,
    DCFList,
    DashboardMarketplaceTicker,
    SuccessionReadinessWidgetContainer,
    PartialSalesContainer,
    SuccessionPartialSalesContainer,
    SuccessionPartialSalesWizard,
    SupportDrawerContainer,
    LeadDrawerContainer,
    AIHeadline,
    AIBio,
    SuccessionDashboard: SuccessionDashboardContainer,
    SuccessionQuestionnaireContainer: SuccessionQuestionnaireContainer,
    SuccessionRolodex: SuccessionRolodexContainer,
    SuccessionSponsoredOwners: SuccessionSponsoredOwnersContainer,
    SuccessionValuation: SuccessionValuationContainer,
    MultiLineValuation: MultiLineValuationContainer,
    ValuationTile: ValuationTileContainer,
    BCPGenerator: BCPGeneratorContainer,
    BcpTile: BcpTileContainer,
    CatastropheGenerator: CatastropheGeneratorContainer,
    CatastropheTile: CatastropheTileContainer,
    SuccessionPlanningGenerator: SuccessionPlanningGeneratorContainer,
    SuccessionPlanningTile: SuccessionPlanningTileContainer,
    SuccessionPlanningSummaryPage,
    HeaderWrapper,
    UnifiedIntakeContainer,
    ConsultantAssessment: ConsultantAssessmentContainer,
    ConsultantAssessmentReport: ConsultantAssessmentReport,

    // Succession Cash Flow Analysis
    CfaHome: CfaContainer,
    CfaWizard: CfaWizardContainer,
    CfaEdit: CfaEditContainer,
    CfaResults: CfaResultsContainer,


    // New Succession CFA Components
    SuccessionCfaStart: SuccessionCfaStartContainer,
    SuccessionCfaWizard: SuccessionCfaWizardContainer,
    EducationContainer,
    MediaContact: MediaContactContainer,
    GettingStartedContainer,
    SuccessionListSearch: SuccessionListSearchContainer,
    SuccessionMapSearch: SuccessionMapSearchContainer,
    SuccessionProfileDrawer: SuccessionProfileDrawerContainer,
    SuccessionProfileDrawerContainer: SuccessionProfileDrawerContainer,
    SuccessionDeals: SuccessionDealsContainer,
    ScheduleMeeting: ScheduleMeetingContainer,
    BuyerRoom: BuyerRoomContainer,
    BuyerRoomGraphQL: BuyerRoomGraphQLContainer,
    BuyerWorkflowControls: BuyerWorkflowControlsContainer,
    BuyerReadinessAssessment: BuyerReadinessAssessmentContainer,
    ModernMessaging: ModernMessagingContainer,
    ChatPanel,
    SellerValueMetric: SellerValueMetricContainer,
    ProvinceMapModal: ProvinceMapModalContainer,
    Onboarding: OnboardingWizard,
    OnboardingWizard: OnboardingWizard,
    SuccessionProfileEditContainer: SuccessionProfileEditContainer,
    ThemeToggle: ThemeToggleContainer,
    SuccessionThemeProvider,
    SuccessionMessages: SuccessionMessagesContainer,
    SuccessionSettings: SuccessionSettingsContainer,
    QuickNotesForm: QuickNotesFormContainer,
    QuickNotes: QuickNotesContainer,
    QuickNotesReportsContainer: QuickNotesReportsContainer,
    ThemeToggle: ThemeToggleContainer,
    SuccessionThemeProvider,
    SuccessionMessages: SuccessionMessagesContainer,
    PersonalFinancialReadiness: PersonalFinancialReadinessContainer,
    OwnerDiagnostic: OwnerDiagnosticContainer,
    WealthGapWizard: WealthGapWizardContainer,
    ProfitGapWizard: ProfitGapWizardContainer,
    ValueGapWizard: ValueGapWizardContainer,
    ActionPlanSelection: ActionPlanSelectionContainer,
    SprintHeader,
    SprintMetricsStripSimple,
    SprintListTable,
    SprintKanbanBoard,
    ValueAccelerationSprintContainer,
    MapTable,
    MapFilters,
    SprintsListContainer,
    SprintsList: SprintsListPage,
    SprintDetailContainer,
    AdvisorMapBacklogContainer,
    AdvisorMapBacklogPage,
    SprintDetailPage,
    AssessmentPromptPage,
    HomeContainer,
    HomePageContainer,
    GuidedTour: require('../bundles/FindBob/components/Shared/GuidedTour/GuidedTour').default,
    SidebarNavigation,
    TopCategories,
    SuccessionCategoryPage,
    SuccessionCategoryPageContainer,
    GrowthCategoryPageContainer,
    ValueAccelerationCategoryPageContainer,
    OpportunitiesCategoryPageContainer,
    ModernizedMotivationOnboarding: ModernizedMotivationOnboardingContainer,
    EducationalContent,
    LaunchPadContainer,
    PactBuilderContainer,
    AssistantPage,
    AssistantModalTest,
    MultiLineAdmin: MultiLineAdminContainer,
    AdminUserValuation: AdminUserValuationPage,
    VaultContainer: VaultContainer,
    QuickbooksConnect: QuickbooksConnectContainer,
    CoachLedMarketplace: CoachLedMarketplacePage,
    CoachLedProgramDetail: CoachLedProgramDetailPage,
    CoachLedProgramEnrollment: CoachLedProgramEnrollmentPage,
    CoachLedCoachProfile: CoachLedCoachProfilePage,
    CoachLedAdminMarketplace: CoachLedAdminMarketplacePage,
    CoachLedEnrollmentWorkspace: CoachLedEnrollmentWorkspacePage,
    CoachLedCoachPortal: CoachLedCoachPortalPage,
    CoachLedParticipantValuation: CoachLedParticipantValuationPage,
    CoachLedProgramEditor: CoachLedProgramEditorPage,
    CoachProfileSettings: CoachLedCoachProfileSettingsPage,
    // Email Platform
    EmailTemplates: TemplateListContainer,
    EmailTemplateBuilder: TemplateBuilderContainer,
    EmailSequences: SequenceListContainer,
    EmailSequenceBuilder: SequenceBuilderContainer,
    EnrollmentManager: EnrollmentManagerContainer,
    EmailTriggers: TriggerListContainer,
    EmailTriggerBuilder: TriggerBuilderContainer,
    EmailAuditLog: EmailLogViewerContainer,
    
    // Plan Builder
    PlanBuilder,
    SuccessionPlansIndex,
    NewSuccessionPlan,
    PlanCompletionCelebration,
    PlanExport,
    
    // Student Platform
    StudentLanding,
    StudentSignup,
    StudentDashboard,
    StudentProfile,
    OpportunityDetail,
    StudentMessagesContainer,
    HiringPostDetail,
    HiringPostForm,
    MyHiringPosts,
    StudentProspectsContainer,
    RecruitmentHub: RecruitmentHubContainer,
    
    // Support System
    SupportHelpDrawerContainer,
    HelpCenter,
    ManagerViewContainer,

    // Succeedo SMB Platform
    SucceedoLogin: SucceedoLoginContainer,
    SucceedoSponsorLanding: SucceedoSponsorLandingContainer,
    PersonaWizard: SucceedoPersonaWizardContainer,
    SucceedoHome: SucceedoDashboardContainer,
    SucceedoGeorge: SucceedoGeorgeContainer,
    SucceedoWorkspace: SucceedoWorkspaceContainer,
    SucceedoAssessment: SucceedoAssessmentContainer,
    SucceedoValuation: SucceedoValuationContainer,
    SucceedoPartnerDirectory: SucceedoPartnerDirectoryContainer,
    SucceedoPartnerProfile: SucceedoPartnerProfileContainer,
    PartnerOnboardingWizard: SucceedoPartnerOnboardingContainer,
    SucceedoDealRoom: SucceedoDealRoomContainer,
    SucceedoDealRoomListing: SucceedoDealRoomListingContainer,
    SucceedoDealRoomEdit: SucceedoDealRoomEditContainer,
    SucceedoMarketplace: SucceedoMarketplaceContainer,
    SucceedoMarketplaceListing: SucceedoMarketplaceListingContainer,
    SucceedoDealRoomInquiries: SucceedoDealRoomInquiriesContainer,
    SucceedoSavedSearches: SucceedoSavedSearchesContainer,
    SucceedoActionPlan: SucceedoActionPlanContainer,
    PartnerDashboard: SucceedoPartnerDashboardContainer,
    PartnerLeadDetail: SucceedoPartnerLeadDetailContainer,
    PartnerMessages: SucceedoPartnerMessagesContainer,
    SucceedoMessages: SucceedoMessagesContainer,
    SucceedoPartnerSignup: SucceedoPartnerSignupContainer,
    PartnerEngagements: SucceedoPartnerEngagementsContainer,
    PartnerEarnings: SucceedoPartnerEarningsContainer,
    PartnerProfileEditor: SucceedoPartnerProfileEditorContainer,
    SucceedoFinancingCalculator: SucceedoFinancingCalculatorContainer,
    SucceedoDealStructure: SucceedoDealStructureContainer,
    SucceedoProfile: SucceedoProfileContainer,
    SucceedoUnderstanding: SucceedoUnderstandingContainer,
    SucceedoTeam: SucceedoTeamContainer,
    SucceedoDealTeamWorkspace: SucceedoDealTeamWorkspaceContainer,
    SucceedoDealTeamSnapshotView: SucceedoDealTeamSnapshotViewContainer,
    SucceedoIntegrations: SucceedoIntegrationsContainer,

    // JIT External User Data Sync
    JitSyncPending,

    // Identity sign-up email activation (require_identity_activation)
    ActivationCheckEmail: ActivationCheckEmailContainer,
});